import ConfirmDialog from './ConfirmDialog.vue'
import DialogBox from './DialogBox.vue'

export {
  ConfirmDialog,
  DialogBox
}
